import React, { Component, Fragment } from 'react';

import { Table, AutoSizer, SortDirection } from 'react-virtualized';

import moment from 'moment';

import { AccentColor } from 'helpers/AccentColorHelper';
import { groupedTableData } from 'helpers/tableHelpers';
import { sortAlphaNum } from 'helpers/utilities';
import { colors } from 'helpers/ColorHelper';

export default class ReactVirtualizedTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sortedList: props.data,
      sortBy: '',
      sortDirection: SortDirection.ASC,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState(
      {
        sortedList: nextProps.data,
      },
      function() {
        this.forceUpdate();
      }
    );
  }

  renderTable = index => {
    if (index === -1) {
      return {
        backgroundColor: '#fdfdfd',
        color: colors.DARK_GRAY,
        borderBottom: `3px solid ${AccentColor()}`,
        fontFamily: `Circular`,
      };
    }
  };

  sort = ({ sortBy, sortDirection }) => {
    let sortedList = this.state.sortedList;
    // https://stackoverflow.com/questions/643782/how-to-check-whether-an-object-is-a-date
    if (sortBy.toLowerCase().includes('date')) {
      sortedList = this.state.sortedList.sort((a, b) => {
        return moment.utc(a[sortBy]).diff(moment.utc(b[sortBy]));
      });
    } else {
      sortedList = sortedList.sort((a, b) => sortAlphaNum(a[sortBy], b[sortBy]));
    }

    sortedList = sortDirection === SortDirection.DESC ? sortedList.reverse() : sortedList;
    this.setState({ sortBy, sortDirection, sortedList });
  };

  rowHeight = (index, tableData) => {
    return tableData[index].tableHeader ? 35 : 50;
  };

  render() {
    const list = this.state.sortedList;
    const tableData = this.props.grouped ? groupedTableData(list) : list;

    return (
      <Fragment>
        <AutoSizer>
          {({ height, width }) => (
            <Table
              width={width}
              height={height}
              headerHeight={40}
              rowHeight={({ index }) => this.rowHeight(index, tableData)}
              rowCount={tableData.length}
              rowGetter={({ index }) => tableData[index]}
              rowStyle={({ index }) => this.renderTable(index)}
              sort={this.sort}
              sortBy={this.state.sortBy}
              sortDirection={this.state.sortDirection}
              {...this.props}
            >
              {this.props.children}
            </Table>
          )}
        </AutoSizer>
      </Fragment>
    );
  }
}
